import { IconButton, styled, Tooltip } from '@ethings/ui-toolkit';
import { ComponentProps, FC, useState, type JSX } from 'react';
import { useSmallScreen } from '../../hooks';

interface IconWithTooltipProps extends Omit<ComponentProps<typeof Tooltip>, 'children'> {
  'data-testid'?: string;
  icon: JSX.Element;
}

const StyledIconButton = styled(IconButton)({
  '&:hover': { backgroundColor: 'transparent' },
});

export const IconWithTooltip: FC<IconWithTooltipProps> = ({
  icon,
  ...rest
}) => {
  const smallScreen = useSmallScreen();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = (): void => {
    if (smallScreen) setTooltipOpen((prev) => !prev);
  };

  return (
    <Tooltip
      {...rest}
      disableFocusListener={smallScreen}
      disableTouchListener={smallScreen}
      {...(smallScreen && {
        open: tooltipOpen,
        onOpen: () => setTooltipOpen(true),
        onClose: () => setTooltipOpen(false),
        slotProps: { popper: { disablePortal: true } },
      })}
    >
      <StyledIconButton disableRipple onClick={toggleTooltip}>
        {icon}
      </StyledIconButton>
    </Tooltip>
  );
};
